import { render } from "./MyPage.vue?vue&type=template&id=f28b2fa2&scoped=true&ts=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"

import "./MyPage.vue?vue&type=style&index=0&id=f28b2fa2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28b2fa2"]])

export default __exports__